<template lang="pug">
.pa-4.primary.rounded-l-lg.d-flex.align-center.w-100.main-header-top
  v-text-field.rounded-pill.mr-8(
    v-model="search",
    label="Buscar",
    solo,
    flat,
    dense,
    hide-details,
    append-icon="fas fa-search"
  )
  v-btn.px-2(
    :href="getTelLinkFromPhone(informations.tel)",
    target="_blank",
    text,
    color="white"
  )
    v-icon.mr-2(color="white", small) fas fa-phone
    .text-body-1
      .open-sans {{ informations.tel }}
  v-divider.white.lighten-2.ml-2.mr-3.my-1(vertical)
  tooltip.ml-2.d-block(
    v-for="(s, i) in social",
    :key="i",
    :tip="s.title",
    bottom
  )
    v-btn.mb-1(
      :href="s.link",
      color="white",
      target="_blank",
      fab,
      depressed,
      x-small
    )
      v-icon(color="primary") {{ s.icon }}
</template>

<script>
import { getTelLinkFromPhone } from "@/components/utils.js";
import Tooltip from "@/components/tools/Tooltip";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return [
        {
          title: "Facebook",
          link: this.informations.facebook,
          icon: "fab fa-facebook-f",
        },
        {
          title: "Instagram",
          link: this.informations.instagram,
          icon: "fab fa-instagram",
        },
        {
          title: "Youtube",
          link: this.informations.youtube,
          icon: "fab fa-youtube",
        },
      ];
    },
    query() {
      return this.$route.query;
    },
    search: {
      get() {
        return this.query.s || "";
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.s = v;
        else delete query.s;

        delete query.p;

        this.$router.push({ path: "/produtos", query });
      },
    },
  },
  methods: {
    getTelLinkFromPhone,
  },
  components: {
    Tooltip,
  },
};
</script>

<style>
.main-header-top {
  position: relative;
}
.main-header-top::after {
  content: "";
  display: block;
  position: absolute;
  background: var(--v-primary-base);
  top: 0;
  height: 100%;
  right: calc((100vw - var(--container-width) + 30px) / 2 * -1);
  width: calc((100vw - var(--container-width) + 32px) / 2);
}

@media (min-width: 960px) {
  .main-header-top::after {
    --container-width: 900px;
  }
}
@media (min-width: 1264px) {
  .main-header-top::after {
    --container-width: 1185px;
  }
}
@media (min-width: 1904px) {
  .main-header-top::after {
    --container-width: 1785px;
  }
}
</style>
